import Vue from 'vue';
import Vuex from 'vuex';
import { state, mutations, actions, getters } from './mutations.js';
import blog from './modules/blog.js';
import tablePreferences from './modules/tablePreferences.js';
import calendarEvents from './modules/calendarEvents.js';
import promotion from './modules/promotion.js';
import featureAnnouncements from './modules/featureAnnouncements.js';
import apiCache from './modules/apiCache.js';
import driverHourlyRates from './modules/driverHourlyRates.js';
import billingProfiles from './modules/billingProfiles.js';
import cashJournals from './modules/cashJournals.js';
import settlements from './modules/settlements.js';
import worktime from './modules/worktime.js';
import externalTripImport from './modules/externalTripImport.js';
import notificationBanners from './modules/notificationBanners.js';

Vue.use(Vuex);

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        blog,
        tablePreferences,
        calendarEvents,
        promotion,
        featureAnnouncements,
        apiCache,
        driverHourlyRates,
        billingProfiles,
        cashJournals,
        settlements,
        worktime,
        externalTripImport,
        notificationBanners,
    },
});
